import React from 'react';
import { Button } from 'reactstrap';
import { DataTable, Field } from '../../commons/DataTable';
import DateTimeField from '../../commons/DataTable/DateTimeField';
import { BtnModalTable } from '../../styled-components';

function InteractionsTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  onOpenDetail,
}) {
  const DettaglioCell = ({ data: rowData }) => (
    <BtnModalTable
      type="button"
      onClick={() => onOpenDetail && onOpenDetail(rowData)}
    >
      Dettaglio
    </BtnModalTable>
  );

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
    >
      <Field title="Tipo" source="tipo" />
      <DateTimeField
        title="Data"
        source="date_added"
        format="DD/MM/YYYY HH:mm"
      />
      <DettaglioCell title="Azioni" />
    </DataTable>
  );
}

export default InteractionsTable;
